import { render, staticRenderFns } from "./PricePanelEditModalWrapper.vue?vue&type=template&id=2e899e9d"
import script from "./PricePanelEditModalWrapper.vue?vue&type=script&lang=js"
export * from "./PricePanelEditModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports